import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const MeetingsListSkeleton: React.FC = () => (
  <div className="space-y-3">
    <div className="flex items-center gap-3 flex-wrap py-2">
      <Skeleton className="h-6 w-24" />
      <Skeleton className="h-8 flex-1 min-w-[200px]" />
      <Skeleton className="h-8 w-32" />
    </div>
    {[0, 1, 2, 3].map((i) => (
      <div key={i} className="flex items-center gap-4 p-4 border rounded-lg">
        <div className="flex-1 space-y-2">
          <div className="flex items-center gap-2">
            <Skeleton className="h-5 w-64" />
            <Skeleton className="h-5 w-20" />
            <Skeleton className="h-5 w-24" />
          </div>
          <div className="flex items-center gap-6">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-4 w-20" />
            <Skeleton className="h-4 w-32" />
          </div>
        </div>
        <div className="flex gap-1">
          <Skeleton className="h-8 w-8" />
          <Skeleton className="h-8 w-8" />
        </div>
      </div>
    ))}
  </div>
)

export default MeetingsListSkeleton
